var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconlyBoldTickSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.63,
    height: 21.63,
    viewBox: "0 0 21.63 21.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Tick-Square",
    "data-name": "Iconly/Bold/Tick-Square",
    transform: "translate(-0.925 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-dropdown-circle",
    "data-name": "Icon ionic-ios-arrow-dropdown-circle",
    d: "M3.375,14.19A10.815,10.815,0,1,0,14.19,3.375,10.813,10.813,0,0,0,3.375,14.19Zm15.032-2.257a1.007,1.007,0,0,1,1.419,0,.991.991,0,0,1,.291.707,1.009,1.009,0,0,1-.3.712l-4.9,4.888a1,1,0,0,1-1.383-.031l-4.976-4.96a1,1,0,0,1,1.419-1.419L14.2,16.088Z",
    transform: "translate(-2.45 -1.375)",
    fill: "#4671a4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyBoldTickSquare);
export default __webpack_public_path__ + "static/media/Iconly-Bold-Tick-Square.6b158394f5075ca20c5f97fc3b71adcf.svg";
export { ForwardRef as ReactComponent };